import { GetterTree, MutationTree, ActionTree, Module } from "vuex";
import { RootState } from "..";
import { UserModel, UserClient } from "@/core/api/apiClient";
import Vue from "vue";

class UsersState {
  items: UserModel[] | undefined = undefined;
}

export const state: UsersState = {
  items: undefined
};

const namespaced: boolean | undefined = true;

const getters = {
  items(state) {
    if (!state.items) return [];

    return state.items.sort((a, b) => (a.role < b.role ? -1 : 1));
  },
  item:
    (state) =>
    (UserId: string): UserModel | undefined => {
      if (!state.items) {
        return undefined;
      }

      const user = state.items.find((x) => x.userId == UserId);

      return user;
    }
} as GetterTree<UsersState, any>;

const mutations = {
  SET_USERS(state, users: UserModel[]) {
    state.items = users;
  },
  UPDATE_USER(state, user: UserModel) {
    if (!state.items) return;

    const existingItem = state.items.findIndex((x) => x.userId === user.userId);

    if (existingItem !== -1) {
      Vue.set(state.items, existingItem, user);
    } else {
      state.items.push(user);
    }
  },
  REMOVE_USER(state, UserId: string) {
    if (state.items != undefined) {
      state.items = state.items?.filter((x) => x.userId != UserId);
    }
  }
} as MutationTree<UsersState>;

const actions = {
  async removeUser({ commit }, user: UserModel): Promise<any> {
    const userClient = new UserClient();

    await userClient.delete(user.clientId, user.userId).then(async () => {
      commit("REMOVE_USER", user.userId);
    });
  }
} as ActionTree<UsersState, any>;

export const users: Module<UsersState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
